import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { deleteMaterialService, getAllMaterialPersianGroupsService, getAvailableMaterialsService, getMaterialIndex } from '../../services/materialsService.js';
import DataTablePagination from '../../components/Table/DataTablePagination.jsx';
import Actions from './additionFields/Actions.jsx';
import Confirm from '../../utils/Confirm.js';
import MaterialSummary from './additionFields/MaterialSummary.jsx';
import { toast } from "react-toastify";

const Materials = () => {
    const [forceRequest, setForceRequest] = useState(0);
    const [options, setOptions] = useState([{ value: "", text: "همه" }]);

    const checkBoxes = [
        {
            label: "فقط مواد موجود",
            value: "cost__gt",
            checked: false
        },
        {
            label: "فقط مواد با قابلیت ماشینکاری مشخص",
            value: "machinability__gt",
            checked: false
        },
    ];

    const navigate = useNavigate();

    const materialCols = [
        {
            field: "id",
            text: "#"
        },
        {
            field: "persian_class",
            text: "کلاس"
        },
        {
            field: null,
            text: "گروه",
            element: (rowData) => <MaterialSummary rowData={rowData} />
        },
        {
            field: null,
            text: "جزئیات ماده اولیه",
            element: (rowData) => {
                return (
                    <Button variant="contained" color="success"
                        onClick={() => navigate("/materials/material", {
                            state: rowData
                        })}
                    >
                        اطلاعات ماده اولیه
                    </Button>
                )
            }
        },
        {
            field: null,
            text: "عملیات‌ها",
            element: (rowData) => <Actions rowData={rowData} handleDeleteMaterial={handleDeleteMaterial} />
        }
    ];

    const handleDeleteMaterial = async (materialData) => {
        const result = await Confirm("تایید عملیات", `آیا از حذف ماده اولیه "${materialData.id}" مطمئن هستید؟`, "info", true, "لغو", "بله")
        if (result) {
            try {
                const response = await deleteMaterialService(materialData.id);
                if (response.status === 204) {
                    setForceRequest(prevValue => prevValue + 1);
                }
            } catch (error) {

            }
        }
    }

    const handleGetAllMaterialPersianGroups = async () => {
        try {
            const response = await getAllMaterialPersianGroupsService();
            if (response.status === 200) {
                const persianGroupOptions = response.data.map(p => ({
                    value: p.persian_group,
                    text: p.persian_group
                }));
                setOptions(prevValue => [...prevValue, ...persianGroupOptions]);
            }
        } catch (error) {

        }
    }

    const createMaterialIndex = async () => {
        try {
            const response = await getMaterialIndex();
            if (response.status === 200) {
                toast.success("ایندکس گذاری مواد اولیه انجام شد");
            }
        } catch (error) {
            toast.error("فرایند ایندکس گذاری متریال با مشکل مواجه شد.")
        }
    }

    const getMaterialIndexHandler = (e) => {
        e.target.style.display = "none"
        createMaterialIndex();
    }

    useEffect(() => {
        handleGetAllMaterialPersianGroups();
    }, []);

    return (
        <DataTablePagination
            tableCols={materialCols}
            title={"مواد اولیه"}
            APIFunction={getAvailableMaterialsService}
            dataField={"results"}
            hasOutlet={true}
            hasCatergory={true}
            categoryOptions={options}
            forceRequest={forceRequest}
            hasCheckBox={true}
            checkBoxes={checkBoxes}
        >
            <Link to="/materials/add-material"
                className="bg-primary px-3 py-1 my-1.5
                rounded-lg text-white">
                افزودن ماده اولیه
            </Link>
            {/* <button onClick={(e) => getMaterialIndexHandler(e)} className='bg-red-600 px-3 py-1 my-1.5 rounded-lg text-white'>
                ایندکس گذاری مواد اولیه
            </button> */}
        </DataTablePagination>
    );
}

export default Materials;
